import React from 'react';
import { NavLink } from 'react-router-dom';
import './Home.css';
import ImageCarousel from './ImageCarousel';
import VirtualTour from './VideoSection';
import PhotoSection from './PhotoSection';
import SpecialGuests from './SpecialGuest';

const principles = [
  {
    title: 'Mission',
    text: 'We create an inclusive learning environment where every student grows academically, socially, and personally with confidence.'
  },
  {
    title: 'Vision',
    text: 'We aim to shape future-ready learners through strong values, academic rigor, and a culture that rewards curiosity.'
  },
  {
    title: 'Focus',
    text: 'Our classrooms emphasize personal attention, practical learning, critical thinking, and steady character development.'
  }
];

const facilities = [
  {
    title: 'Library',
    image: '/external/images/library.jpeg',
    text: 'A calm reading space that supports research, imagination, and independent thinking.'
  },
  {
    title: 'Playground',
    image: '/external/images/playground.jpeg',
    text: 'Safe outdoor areas designed to support movement, teamwork, and everyday confidence.'
  },
  {
    title: 'Science Labs',
    image: '/external/images/sciencelabs.jpeg',
    text: 'Hands-on learning spaces where students test ideas and connect science to the real world.'
  }
];

const highlights = [
  { value: 'Holistic', label: 'Student development' },
  { value: 'Future-ready', label: 'Skills & exposure' },
  { value: 'Community-led', label: 'Supportive culture' }
];

const Home = () => {
  return (
    <div className="home-page">
      <section
        className="header"
        style={{
          backgroundImage: `linear-gradient(115deg, rgba(5, 22, 45, 0.84), rgba(11, 38, 70, 0.48)), url(${process.env.PUBLIC_URL}/external/images/cover.jpeg)`
        }}
      >
        <div className="hero-backdrop"></div>
        <div className="text-box">
          <span className="hero-kicker">Maxfort Education School</span>
          <h1>Confident learning in a modern school environment.</h1>
          <p>
            Academic focus, supportive teaching, and a campus designed for student growth in
            Partapur, Banswara.
          </p>

          <div className="hero-actions">
            <NavLink className="hero-btn hero-btn--solid" to="/contact">
              Book a Campus Visit
            </NavLink>
            <NavLink className="hero-btn hero-btn--ghost" to="/about">
              Explore the School
            </NavLink>
          </div>

          <div className="hero-highlights">
            {highlights.map((item) => (
              <div key={item.label} className="hero-highlight">
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-panel">
          <p className="hero-panel__eyebrow">Why families choose Maxfort</p>
          <div className="hero-panel__list">
            <div>
              <strong>Academic commitment</strong>
              <span>Balanced with personal attention and values-led development.</span>
            </div>
            <div>
              <strong>Campus experience</strong>
              <span>Better environments for exploration, sports, labs, and events.</span>
            </div>
            <div>
              <strong>Trusted community</strong>
              <span>Built for parents seeking structure, warmth, and visible growth.</span>
            </div>
          </div>
        </div>
      </section>

      <section className="principles section-shell">
        <div className="section-heading">
          <span className="section-kicker">Foundations</span>
          <h2>Our core principles shape every classroom and student interaction.</h2>
          <p>
            A strong school experience is not only about results. It is about environment,
            consistency, and the confidence students carry with them every day.
          </p>
        </div>

        <div className="principles-grid">
          {principles.map((item, index) => (
            <article className="principles-col" key={item.title}>
              <span className="principles-col__index">0{index + 1}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="facilities section-shell">
        <div className="section-heading">
          <span className="section-kicker">Campus Resources</span>
          <h2>Purposeful spaces that support learning beyond the classroom.</h2>
          <p>
            Every facility is designed to make the student experience richer, more engaging,
            and better suited to modern school life.
          </p>
        </div>

        <div className="row">
          {facilities.map((item) => (
            <article className="facilities-col" key={item.title}>
              <img src={item.image} alt={item.title} />
              <div className="facilities-col__content">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="campus-resources section-shell">
        <div className="section-heading section-heading--centered">
          <span className="section-kicker">Life at Maxfort</span>
          <h2>Inside the campus: facilities, energy, and student moments.</h2>
        </div>
        <div className="content-panel">
          <ImageCarousel />
        </div>
      </section>

      <section className="atl-container section-shell">
        <div className="section-heading section-heading--centered">
          <span className="section-kicker">Innovation</span>
          <h2>Visit to the Atal Tinkering Lab.</h2>
        </div>
        <div className="content-panel">
          <PhotoSection />
        </div>
      </section>

      <section className="specialGuest-section section-shell">
        <div className="section-heading section-heading--centered">
          <span className="section-kicker">Featured Guests</span>
          <h2>Inspiring voices that expand student perspective.</h2>
        </div>
        <div className="content-panel">
          <SpecialGuests />
        </div>
      </section>

      <section className="video-container section-shell">
        <div className="section-heading section-heading--centered">
          <span className="section-kicker">Virtual Tour</span>
          <h2>See the campus atmosphere before you visit in person.</h2>
        </div>
        <div className="content-panel">
          <VirtualTour />
        </div>
      </section>
    </div>
  );
};

export default Home;
